import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { getQuestionDetails } from "../../../api/endpoints/QuestionEndpoints";

export default function useGetQuestionDetails(
  quizId: string,
  questionId: string,
) {
  const getExerciseDetailsFn = useCallback(() => {
    return getQuestionDetails(quizId, questionId);
  }, [quizId, questionId]);

  return useQuery({
    queryKey: ["question", quizId, questionId],
    queryFn: getExerciseDetailsFn,
  });
}
